const BookingItem = {
  refundMethod: () => null,
  isPrrAttempted: () => false
};

export default BookingItem;
